import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';

const AuthCallback: React.FC = () => {
  const { isLoading, isAuthenticated, error } = useAuth0();

  if (!isLoading) {
    if (isAuthenticated) return <Navigate to='/' />
    if (error) {
      console.error(error)
      return <Navigate to='/' />
    }
  }

  return <div>Logging in...</div>;
};

export default AuthCallback;